import { TeamMember } from '../../store/GeneralStore';
import { callExternalApi, CallResult } from '../callExternalApi';

export async function fetchAssetTeam(assetId: string, accountId?: string): Promise<CallResult<TeamMember[]>> {
  if (!accountId) return { data: null, error: { message: 'Must provide account ID to fetch asset team' } };

  return await callExternalApi<TeamMember[]>({
    url: `api/inventory/team/${assetId}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json',
      AccountScope: accountId
    }
  });
}
